module.exports = __webpack_public_path__ + "img/title.5e63e9c9.png";